import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

/**
 * Edit/delete action buttons for a row in the extensions grid.
 * Hidden for the synthetic original-contract row (it is locked).
 * Delegates to the parent component via grid context.
 */
@Component({
    selector: "app-extension-actions",
    standalone: true,
    imports: [],
    template: `
        @if (!isOriginalContract) {
            <div class="action-container">
                <button class="action-btn" (click)="onEdit()">
                    <i class="fa fa-pencil"></i>
                </button>
                <button class="action-btn" (click)="onDelete()">
                    <i class="fa fa-trash-o"></i>
                </button>
            </div>
        }
    `,
    styles: [`
        .action-container { display: flex; justify-content: center; align-items: center; gap: 8px; height: 100%; width: 100%; }
        .action-btn { background-color: #2f3447; color: white; cursor: pointer; border-radius: 50%; width: 30px; height: 30px; display: flex; justify-content: center; align-items: center; border: none; }
    `]
})
export class ExtensionActionsComponent implements ICellRendererAngularComp {
    public isOriginalContract = false;
    private params: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.isOriginalContract = !!(params.data as any)?.isOriginalContract;
    }

    refresh(): boolean {
        return false;
    }

    onEdit(): void {
        (this.params.context as any)?.parentComponent?.editExtension(this.params.data);
    }

    onDelete(): void {
        (this.params.context as any)?.parentComponent?.deleteExtension(this.params.data);
    }
}
